import React, { ReactElement } from 'react'
import FreeDns from 'components/FreeDns'
import { AlertContextProvider, TrayContextProvider } from 'ui'
import { getDocumentHead } from 'components/DocumentHead'
import { CONTROLDText } from 'ui/CONTROLD'

export default function FreeDNSPage(): ReactElement {
  return (
    <AlertContextProvider>
      <TrayContextProvider>
        <FreeDns />
      </TrayContextProvider>
    </AlertContextProvider>
  )
}

export const Head = getDocumentHead({
  title: `Free DNS Servers - Anonymize Your Internet`,
  description: `Free DNS servers from ${CONTROLDText} help safeguard your devices from malware, unsecured public wifi, ads, and more. Sign up today and stay safe online.`,
})
